export const referenceCardSelectedPagRefName = 'referenceCardSelectedPagRef';

export const referenceCardSelectedPagRefProjection = `{
  _id,
  _type,
  wistiaVideoMetadata,
  cardImage,
  currentPathname,
  title,
  cardButtonText,
  description,
  articleDate,
}`;

export const referenceCardSelectedPagRefQuery = groq`*[_id == $_id][0] ${referenceCardSelectedPagRefProjection}`;
